import styled from '@emotion/styled'
import { MenuItem } from '@mui/material'
import { getThemeSpacing } from '../styles/appTheme'
import { APP_FONT } from '../theme'

export const MENU_ITEM_PADDING = getThemeSpacing(1, true)

export const StyledMenuItem = styled(MenuItem)({
    fontFamily: APP_FONT,
    padding: MENU_ITEM_PADDING,
    fontSize: '0.8rem',
})
